import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import {
    FlowOfFunds,
    SaveConsiderationChangeNoteRequest,
} from '../../../../models/FlowOfFunds/flow-of-funds.model';

export interface SaveConsiderationChangeNoteParams extends SaveConsiderationChangeNoteRequest {
    engagementId: number;
    changeId: number;
}

export interface SaveConsiderationChangeNoteRejection {
    isConflict: boolean;
}

export const SaveConsiderationChangeNote = createAsyncThunk(
    'flowOfFunds/saveConsiderationChangeNote',
    async (params: SaveConsiderationChangeNoteParams, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.put(
                `/api/PurchasePriceConsideration/${params.engagementId}/Changes/${params.changeId}/Note`,
                {
                    note: params.note,
                }
            );

            if (response.status !== 200) {
                throw new Error('Failed to save the note');
            }

            return response.data as FlowOfFunds;
        } catch (error) {
            createNotification('Could not save the note.', 'error');
            return dispatch.rejectWithValue({
                isConflict: false,
            } as SaveConsiderationChangeNoteRejection);
        }
    }
);
